/**
 * Детерминированная сериализация значения: ключи объектов идут по алфавиту, массивы — в исходном
 * порядке, поля без значения (`undefined`) пропускаются.
 *
 * Нужна там, где два значения сравниваются на равенство содержимого: `JSON.stringify` зависит от
 * порядка ключей, а он у одних и тех же данных различается — например, запись вернулась с сервера
 * или пережила хранилище.
 */
export const stableStringify = (value: unknown): string => {
  if (value === undefined) return 'undefined';
  if (value === null) return 'null';
  if (Array.isArray(value)) {
    return `[${value.map(stableStringify).join(',')}]`;
  }
  if (typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>)
      .filter(([, entryValue]) => entryValue !== undefined)
      .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0));
    return `{${entries.map(([key, entryValue]) => `${JSON.stringify(key)}:${stableStringify(entryValue)}`).join(',')}}`;
  }
  return JSON.stringify(value);
};
